/* @ngInject */
const movement = (
  movementAsk,
  movementData,
  movementFormat,
  movementGo,
  movementLocal,
  movementMetadata,
  movementRequest,
  movementNew
) => {
  const self = {}

  self.new = movementNew
  self.ask = movementAsk
  self.data = movementData
  self.format = movementFormat
  self.go = movementGo
  self.local = movementLocal
  self.metadata = movementMetadata
  self.request = movementRequest

  return self
}

export default movement



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/movement.service.js